import React, { useCallback, useState } from 'react';
import colorStyle from '../../../styles/utils/variables.module.scss';
import Button from '../../atoms/button/button';
import { ButtonStyleType } from '../../../constants/button-style-type';

export type PdfDownloadButtonProps = {
  onDownloadClick: () => Promise<void>;
};

export const PdfDownloadButton: React.FC<PdfDownloadButtonProps> = ({ onDownloadClick }) => {
  const [isPdfGenerating, setIsPdfGenerating] = useState(false);

  const onDownloadPDFClick = useCallback(async () => {
    setIsPdfGenerating(true);

    await onDownloadClick();

    setIsPdfGenerating(false);
  }, [onDownloadClick]);

  return (
    <Button
      buttonStyle={ButtonStyleType.Filled}
      onClick={onDownloadPDFClick}
      copyColor={colorStyle.white}
      backgroundColor={colorStyle.blue100}
      hoverBackgroundColor={colorStyle.blue100}
      activeBackgroundColor={colorStyle.blue100}
      disabled={isPdfGenerating}
    >
      {isPdfGenerating ? `Generating PDF...` : `Download PDF`}
    </Button>
  );
};
